var Compare = {
    setCompared : function(checkbox, value) {
        $(checkbox).prop('checked', value);

        if (! value) {
            $(checkbox).parent().children('.jq-checkbox').removeClass('checked')
        }
    },
    refreshHeader: function(content) {
        $('.header-viewed .viewed-drop-a').html(content);
        $('.compare-bottom-content').html(content)
        if ($(".footer-compare-group-panel .viewed-item").length == 0) {
            $(".footer-compare-group-panel").removeClass("open")
        } else {
            $(".footer-compare-group-panel").addClass("open")
            $(".compare-footer-btn").click()
        }
    }
};

$(window).on("load", function() {
    $('.compare-checkbox').each(function() {
        if ($(this).prop('checked')) {
            $(this).next("span.jq-checkbox").next("label").attr("title", "Usuń z porównania")
        } else {
            $(this).next("span.jq-checkbox").next("label").attr("title", "Dodaj do porównania")
        }
    })
})

$(document).ready(function() {

    $('#compareSendToEmail').click(function () {
        swal({
            title: 'Podaj adres email',
            input: 'email',
            showCancelButton: true,
            confirmButtonText: 'Wyślij',
            cancelButtonText: 'Anuluj',
            preConfirm: function (email) {
                return new Promise(function (resolve, reject) {
                    $('.swal2-confirm.swal2-styled').attr('disabled', 'disabled');

                    $.post('/compare/send', {email: email}, function () {
                        resolve();
                    });
                    // setTimeout(function() {
                    //     if (email === 'taken@example.com') {
                    //         reject('This email is already taken.')
                    //     } else {
                    //         resolve()
                    //     }
                    // }, 2000)
                })
            },
            allowOutsideClick: false
        }).then(function (email) {
            swal({
                type: 'success',
                title: '',
                html: 'Zestawienie zostało wysłane na adres: ' + email
            })
        });

        return false;
    });
    $('.compare-checkbox').change(function () {
        var checkbox = $(this);
        if ($(this).prop('checked')) {
            checkbox.next("span.jq-checkbox").next("label").attr("title", "Usuń z porównania")
            $.ajax({
                'url': checkbox.data('href'),
                'method': 'POST',
                'data': {
                    'object-slug': checkbox.val()
                },
                success: function (response) {
                    if (response.status == 'max') {
                        swal({
                            title: '',
                            text: 'Możesz dodać maksymalnie 3 obiekty.',
                            type: 'error',
                            confirmButtonColor: '#97762c',
                        });
                        Compare.setCompared(checkbox, false);
                    } else if (response.status == 'ok') {
                        Compare.setCompared(checkbox, true);
                        Compare.refreshHeader(response.content);
                        $.notify("Obiekt został dodany do porównania", "success");
                        $(".compare-checkbox").each(function() {
                            if ($(this).val() == checkbox.val()) {
                                $(this).attr('checked', true)
                                $(this).next("span.jq-checkbox").addClass("checked")
                                $(this).next("span.jq-checkbox").next("label").attr("title", "Usuń z porównania")
                            }
                        })
                    }
                }
            });

        } else {
            checkbox.next("span.jq-checkbox").next("label").attr("title", "Dodaj do porównania")
            $.ajax({
                'url': checkbox.data('href-remove'),
                'method': 'DELETE',
                success: function (response) {
                    if (response.status == 'ok') {
                        Compare.setCompared(checkbox, false);
                        Compare.refreshHeader(response.content);

                        if ($('#comparePage').length) {
                            $('#compare-' + checkbox.val()).fadeOut(function () {
                                $(this).remove();
                                if ($('#obiekty-porowananie > tbody').length == 0) window.location.reload(false);
                            });
                        }
                    }
                }
            });
        }
    });
});
function  deletecompare(obj) {
    var link = $(obj);
    var obj = link.attr('data-value');
    $(".compare-checkbox").each(function() {
        if ($(this).val() == obj) {
            $(this).attr("checked", false);
            $(this).next("span.jq-checkbox").removeClass("checked")
            $(this).next("span.jq-checkbox").next("label").attr("title", "Dodaj do porówniania")
        }
    })
    $.ajax({
        'url' : link.data('href-remove'),
        'method' : 'DELETE',
        success: function (response) {
            if (response.status == 'ok') {
                Compare.setCompared(link, false);
                Compare.refreshHeader(response.content);
            }
        }
    });
}